import { NavLink } from "react-router-dom";

export default function NavBusinessClass({ currentPage = "" }) {
  return (
    <div>
      <ul
        className="nav nav-tabs mb-4 justify-content-center justify-content-sm-start border-bottom"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <NavLink
            to="/courses"
            className={`nav-link${currentPage === "courses" ? " active" : ""}`}
          >
            <i className="fi fi-rr-book-bookmark"></i>
            <span className="d-none d-md-inline-block ms-2">Courses</span>
          </NavLink>
        </li>

        <li className="nav-item" role="presentation">
          <NavLink
            to="/blueprints"
            className={`nav-link${
              currentPage === "blueprints" ? " active" : ""
            }`}
          >
            <i className="fi fi-rr-book"></i>
            <span className="d-none d-md-inline-block ms-2">Blueprints</span>
          </NavLink>
        </li>

        <li className="nav-item" role="presentation">
          <NavLink
            to="/events"
            className={`nav-link${currentPage === "events" ? " active" : ""}`}
          >
            <i className="fi fi-rr-graduation-cap"></i>
            <span className="d-none d-md-inline-block ms-2">Live Events</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
}